import { createApp } from 'vue'
import App from './app.vue'
import elements from './elements'
import router from './router'
import store from './store'

const app = createApp(App)

app.use(elements)
app.use(router)
app.use(store)

app.mount('#app')
